import React from 'react'
import Img from 'gatsby-image'
import { css } from 'emotion';
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import elevation from '../utils/elevation'
import { ReactComponent as InstagramIcon } from '../svg/instagram.svg'

const followButton = css({
  alignItems: 'center',
  backgroundColor: '#fff',
  border: 0,
  borderRadius: 4,
  boxShadow: elevation(2),
  display: 'flex',
  fontSize: '.85rem',
  justifyContent: 'center',
  left: '50%',
  lineHeight: 1,
  minWidth: 200,
  padding: '15px 20px',
  position: 'absolute',
  textDecoration: 'none',
  textTransform: 'uppercase',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  whiteSpace: 'nowrap',
})

const InstagramMural = ({ images }) =>
  <div
    css={{
      position: 'relative',

      '@media (min-width: 700px)': {
        transform: 'translateY(-50%)',
      }
    }}
  >
    <div
      css={{
        margin: '0 auto',
        maxWidth: 700,

        '.gatsby-image-outer-wrapper': {
          display: 'inline-block',
          boxShadow: elevation(5),
          opacity: .8,
          verticalAlign: 'top',
          width: '25%',
  
          '&:hover': {
            opacity: 1,
          },
  
          '@media (min-width: 700px)': {
            width: '16.6666%',

            '&:nth-child(6n)': {
              width: '16.667%'
            },
          },
        },
      }}
    >
      {images.map((image, index) => (
        <Img backgroundColor={true} key={index} sizes={image.node.childImageSharp.sizes} />
      ))}
    </div>
    <OutboundLink
      className={followButton}
      href="https://www.instagram.com/patriciamarques.artist/"
      title="Get in touch through Instagram"
    >
      <InstagramIcon css={{ marginRight: 10, width: '1.5em', height: '1.5em' }} />
      Follow on Instagram
    </OutboundLink>
  </div>

  export default InstagramMural



// WEBPACK FOOTER //
// ./src/components/InstagramMural.js